import { render, staticRenderFns } from "./SiteInvoiceAction.vue?vue&type=template&id=6b6e3c04"
import script from "./SiteInvoiceAction.vue?vue&type=script&lang=js"
export * from "./SiteInvoiceAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports